import { render, staticRenderFns } from "./matchDetail.vue?vue&type=template&id=76ac0f94&scoped=true&"
import script from "./matchDetail.vue?vue&type=script&lang=js&"
export * from "./matchDetail.vue?vue&type=script&lang=js&"
import style0 from "./matchDetail.vue?vue&type=style&index=0&id=76ac0f94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ac0f94",
  null
  
)

export default component.exports